// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Mark from './Mark';

export default class Glossary extends WebComponent {
	constructor(props) {
		super(props);
		this.handleLoadData = this.handleLoadData.bind(this);
	}

	didMount() {
		window.addEventListener('load', this.handleLoadData);
	}

	willUnMount() {
		window.removeEventListener('load', this.handleLoadData);
	}


	handleLoadData(requestUrl) {
		const {
			jsonName,
		} = this.props;


		// eslint-disable-next-line no-undef
		const jsonUrl = `/${projectConfig.lang}/${jsonName}`;

		const xhr = new XMLHttpRequest();
		xhr.onload = () => {
			if ( xhr.status >= 200 && xhr.status < 300 ) {
				const response = JSON.parse(xhr.response);
				this.processData(response);
			} else {
				console.log('Glossary webcomponent :: Data se nepodařilo načíst.');
			}
		};
		xhr.open('GET', jsonUrl);
		xhr.send();
	};

	processData(jsonData) {
		const glossaryData = jsonData.data;
		let keywordsData = "";

		for ( let i = 0; i < glossaryData.length; i++ ) {
			//- console.log(glossaryData[i]);
			if(i == 0) {
				keywordsData += glossaryData[i].keywords.trim()
			} else {
				keywordsData += ', ' + glossaryData[i].keywords.trim();
			}
		}
		this.markKeywords(glossaryData, keywordsData);
	}

	markKeywords(data, keywords) {
		const {
			contextSelector,
			contextExcludes,
			diacritics,
			acrossElements,
			caseSensitive,
			separateWordSearch,
		} = this.props;

		//- console.log('Klíčová slova k označení');
		//- console.log(keywords.replaceAll(",", "|").replaceAll("| ", "|").replaceAll("||", "|"));

		// Mark.JS - https://markjs.io/
		let context = document.querySelector(contextSelector);
		let instance = new Mark(context);
		let keywordsRegExp = new RegExp(keywords.replaceAll(",", "|").replaceAll("| ", "|").replaceAll("||", "|"), 'gim');
		const markSettings = {
			"separateWordSearch": separateWordSearch,
			"diacritics": diacritics,
			"acrossElements": acrossElements,
			"caseSensitive": caseSensitive,
			"exclude": contextExcludes,
			"each": function (e) {
				let markedElm = e;
				// získat označený text
				let markedWord = markedElm.innerText.trim().toLowerCase();
				// vyhledat text v datech keywords
				for ( let i = 0; i < data.length; i++ ) {
					let searchStr = data[i].keywords.replaceAll(", ", ",").trim().toLowerCase();
					//- console.log(searchStr);
					if(searchStr.includes(markedWord)) {
						// nastavíme title
						markedElm.setAttribute("title", data[i].title);
						// nastavíme URL na detail
						markedElm.setAttribute("data-url", data[i].url);
						// nastavíme bind na click
						markedElm.addEventListener('click', function (e) {
							e.preventDefault();
       						e.stopPropagation();
							const targetUrl = e.currentTarget.dataset.url;
							window.location.href = targetUrl;
						});
						//- console.log('Je nastavenej, zkontrolujeme to...');
						//- console.log(markedElm);
						//- console.log(data[i]);
					}
				}
			}
		};
		instance.markRegExp(keywordsRegExp, markSettings);
	}

}

Glossary.defaultProps = {
	jsonName: 'dataglossary.js',
	contextSelector: '.page-body',
	separateWordSearch: false, // Whether to search for each word separated by a blank instead of the complete term
	diacritics: true, // If diacritic characters should be matched.
	acrossElements: false, // Whether to search for matches across elements
	caseSensitive: false, // Whether to search case sensitive
	contextExcludes: [ // An array with exclusion selectors. Matches inside these elements will be ignored.
		"h1",
		"h2",
		"h3",
		"button",
		".btn",
		"a",
		".glossary-exclude *"
	],
};




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Glossary.js